<template>
    <div class="body">
        <!-- 导航栏 -->
        <mslNav></mslNav>
        <!-- 资讯卡片 -->
        <div class="list">
            <div class="item" v-for="(item, index) in list" :key="index" >
                <router-link :to="{ name: 'news_detail', query: { id: item.id } }" class="nd_none a_item">
                    <div class="img_box" v-if="item.image_path">
                        <img :src="item.image_path" alt="">
                    </div>
                    <div class="content">
                        <div class="title w d_ellipsis ta_left">{{ item.title }}</div>
                        <div class="intro w m_ellipsis ta_left">{{ item.content }}</div>
                        <div class="dm space_center">
                            <div class="date">{{ item.create_time }}</div>
                            <div class="check left_center">
                                <span>查看更多</span>
                                <span class="iconfont iconicon-22 youjiantou"></span>
                            </div>
                        </div>
                    </div>
                </router-link>
            </div>
            <noData v-if="list && list.length == 0 && loadingType === 0"></noData>
            <div class="load_area row_center" v-if="loadingType !=0">
                <div class="load_more row_center" v-if="loadingType === 1" @click="getList('load')">
                    加载更多
                </div>
                <div class="loading left_center" v-if="loadingType === 2">
                    <van-loading/>
                    <span class="load_txt">加载中...</span>
                </div>
                <div class="no_more" v-if="loadingType === 3">已加载全部内容</div>
            </div>
        </div>

    </div>
</template>

<script>
    import { newsList } from "../api/common";
    import noData from '../components/no_data'

    export default {
        name: "news",
        components: {
            noData
        },
        data() {
            return {
                baseInfo: {},
                list: [],
                loadingType: 1, // 加载按钮 =》 1； 加载中 =》 2； 全部加载 =》 3
                formData: {
                    page: 1,
                    limit: 4,
                    diyname: 'news'
                }
            }
        },
        mounted() {
            this.getList('init');
        },
        methods: {
            // 列表
            async getList(type) {
                try {
                    // 显示加载中；
                    this.loadingType = 2;
                    // 赋值
                    let list = this.list;
                    // 调用接口；
                    let res = await newsList(this.formData);
                    if (res.code == 1) {
                        // 初始化？ 加载中？
                        if (type == 'init') {
                            list = res.data.list;
                        } else if (type == 'load') {
                            list = list.concat(res.data.list);
                        }
                        // 加载完成？
                        if (res.data.list && res.data.list.length < 4) {
                            this.loadingType = 3;
                        } else {
                            this.loadingType = 1;
                        }
                        // 初始化 没有数据
                        if (res.data.list.length === 0 && data.page === 1) {
                            this.loadingType = 0; // 隐藏全部加载
                        }

                        this.formData.page++;
                        this.list = list;
                        // 内容处理
                        this.list.forEach((item, index) => {
                            if (!!item.content) {
                                let content = item.content;
                                content = content.replace(/(\n)/g, "");
                                content = content.replace(/(\t)/g, "");
                                content = content.replace(/(\r)/g, "");
                                content = content.replace(/<\/?[^>]*>/g, "");
                                content = content.replace(/\s*/g, "");
                                item.content = content;
                                console.log(item.content, 'item.content');
                            }
                        })
                        console.log(list, 'list');
                    }
                } catch {
                    this.errToast('加载数据失败，请刷新');
                }
            }
        }

    }
</script>

<style scoped lang="scss">
    .list {
        padding: 0 16px;
        padding-top: 16px;
        padding-bottom: 24px;
        box-sizing: border-box;
        background-color: #fafafa;
        .item {
            width: 100%;
            overflow: hidden;
            background-color: #fff;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.06);
            border-radius: 8px;
            margin-top: 16px;
            &:first-child {
                margin-top: 0px;
            }
            .img_box {
                width: 100%;
                height: 186px;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .content {
                white-space: normal!important;
                margin-top: 12px;
                padding: 0 16px;
                padding-bottom: 16px;
                box-sizing: border-box;

                .title {
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    line-height: 24px;
                    color: #333333;
                }
                .intro {
                    margin-top: 4px;
                    font-size: 12px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 18px;
                    color: #8C8C8C;
                    &::v-deep {
                        p {
                            margin-top: 0px!important;
                            margin-bottom: 0px!important;
                        }
                    }
                }
                .dm {
                    margin-top: 16px;
                    .date {
                        font-size: 12px;
                        font-family: SF Pro Display;
                        font-weight: 400;
                        line-height: 14px;
                        color: #BFBFBF;
                        opacity: 1;
                    }
                    .check {
                        font-size: 12px;
                        font-family: PingFang SC;
                        font-weight: 400;
                        line-height: 17px;
                        color: #61A4FF;
                        .youjiantou {
                            font-size: 16px;
                            margin-left: 4px;
                        }
                    }
                }
            }
        }


    }

    .load_area {
        margin-top: 24px;
        margin-bottom: 12px;
        .load_more {
            width: 89px;
            height: 34px;
            border: 1px solid rgba(38, 38, 38, .8);
            border-radius: 2px;
            margin-right: 20px;
            font-size: 14px;
            font-family: Alibaba PuHuiTi;
            font-weight: 400;
            line-height: 20px;
            color: rgba(38, 38, 38, .8);
        }
        .no_more {
            color: rgba(38, 38, 38, .8);
            font-size: 12px;
        }
        .loading {
            .load_txt {
                color: rgba(38, 38, 38, .8);
                font-size: 12px;
                margin-left: 12px;
            }
        }
    }

</style>
